import React from "react";
import Carousal from "../../FormFields/NewCarousal/Carousal";

const MessageA48 = (props) => {
  return <Carousal {...props} />;
};

export default MessageA48;
